import { createSelector } from 'reselect'
import getSelectedVariantSelect from 'modules/variant/redux/selectors/get-selected-variant'

const isSelectedVariantOutOfStockVariantSelect = createSelector(
  /**
   * @type {ProductVariantCarouselInfo}
   */
  getSelectedVariantSelect,
  selectedVariant => selectedVariant?.available === false
)

export default isSelectedVariantOutOfStockVariantSelect
